import { Injectable } from '@angular/core';
import { DatasourceTableService, DatasourceTableSettingsCheckService } from '@y42/datasource';
import { ErrorHandlerService } from '@y42/error-handling';
import { Y42FeatureType } from '@y42/json-schema';
import { IntegrationTableJobQuery } from '../../state';
import { IntegrationQuery, IntegrationStore } from '../../state/datasource';
import {
  IntegrationTableGitFactoryService,
  IntegrationTableQuery,
  IntegrationTableStore,
} from '../../state/datasource-table';

@Injectable({ providedIn: 'root' })
export class IntegrationTableService extends DatasourceTableService {
  constructor(
    parentStore: IntegrationStore,
    parentQuery: IntegrationQuery,
    query: IntegrationTableQuery,
    store: IntegrationTableStore,
    jobQuery: IntegrationTableJobQuery,
    gitFactory: IntegrationTableGitFactoryService,
    errorHandlerService: ErrorHandlerService,
    datasourceTableSettingsCheckService: DatasourceTableSettingsCheckService,
  ) {
    super({
      feature: Y42FeatureType.Integration,
      parentStore,
      parentQuery,
      query,
      store,
      jobQuery,
      gitFactory,
      errorHandlerService,
      datasourceTableSettingsCheckService,
    });
  }
}
